export const baseURL = "https://portea.betaphase.in";
export const abaseURL = "https://accounts.travelize.in";
